import { CategoryApiService, ProductApiService } from '@/core';
import { CommonStatusValues, EnableValues } from '@/shared';
import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { ProductEntity } from '@repo/types';
import { constructNow } from 'date-fns';
import { map, switchMap } from 'rxjs';

@Component({
    selector: 'app-products',
    standalone: true,
    imports: [CacTableComponent],
    templateUrl: './products.component.html',
    styleUrl: './products.component.scss',
})
export class ProductsComponent {
    private readonly productApi = inject(ProductApiService);
    private readonly categoryApi = inject(CategoryApiService);

    table = table<ProductEntity>({
        itemsFn: this.productApi.getAdapter(),
        view: {
            itemName: 'Product',
        },
        columns: {
            id: { label: 'ID' },
            name: {
                label: 'Product Name', sortable: true, filterable: [
                    {
                        type: 'contains',
                        key: 'Name',
                    },
                ],
            },
            priority: { label: 'Priority', sortable: true },
            image: { label: 'Image', type: 'image', transform: (v) => v?.url },
            categories: {
                label: 'Categories', type: 'text', filterable: [
                    {
                        type: 'equal',
                        label: 'Categories',
                        key: 'Categories',
                        controlType: 'select',
                        items: this.categoryApi.getAll().pipe(map((categories) => categories.map((v) => ({ value: v.id, label: v.name }))))
                    },
                    {
                        type: 'contains',
                        key: 'Category',
                    },
                ]
            },
            status: {
                label: 'Status',
                items: CommonStatusValues,
                filterable: [
                    {
                        type: 'equal',
                        multiple: true,
                        key: 'statuses',
                        controlType: 'select',
                        items: CommonStatusValues
                    }
                ]
            },
        },
        actions: [
            {
                type: 'icon',
                content: 'edit',
                action: (item: ProductEntity) => dialog$.product({ product: { ...item, } }).afterSubmit(),
            },
            {
                type: 'icon',
                content: 'trash',
                action: (item) => dialog$.deletePrompt(true).action(() => this.productApi.delete(item.id)),
            },
        ],
        events: {
            add: () => dialog$.product().afterSubmit(),
        },
    });
}
